<template>
    <div class="organization" v-show="!$route.query.hideOrganization">
        <!--div class="against">{{msgAgainst}}</div-->
        <img id="logo" :alt="organization.name" v-if="!$route.query.hideLogo" :src="organizationThumb" onerror="document.querySelector('#logo').style.display='none';" />
        <div class="company">
            <h1 class="name">
                <a :href="organization.website" target="blank">{{ organization.name }}</a>
            </h1>
            <span class="address">{{ organization.zipCode }} {{ organization.city }} {{ organization.address }}</span>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        organization: {}
    },
    computed: {
        organizationThumb() {
            return `https://api.codenotary.io/foundation/v1/organisation/${this.organization.name}/thumbnail`;
        },
        msgAgainst: function() {
            return this.$route.query.msgAgainst || this.$t("msgAgainst");
        }
    },
    mounted() {
        const logo = document.getElementById('logo');

        if (logo) {
            logo.setAttribute('draggable', false);
        }
    }
};
</script>
<style scoped lang="scss">
@import '../css/config';

.area:not(.-box) {
    .organization {
        border: 1px solid $border-color;
        border-radius: 4px;
        background: white;
    }
}

.organization {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: $spacer;
    border-bottom: 1px solid $border-color;

    #logo {
        max-width: 80px;
        height: auto;
        margin-right: $spacer;
    }

    .company {
        .name {
            font-size: 18px;
            margin-top: 0;
            margin-bottom: 0.25rem;
        }

        .address {
            display: block;
            font-size: 70%;
            color: $text-muted;
            line-height: 1rem;
        }
    }
}
</style>
